module.exports = __webpack_public_path__ + "static/media/SCREENSHARE_OFF.362ffa2a.svg";